import React from 'react';
import {
  Autocomplete as MUIAutocomplete,
  AutocompleteProps as MUIAutocompleteProps,
  Paper,
} from '@mui/material';

export const Autocomplete = <T,>(
  props: MUIAutocompleteProps<
    T,
    boolean | undefined,
    boolean | undefined,
    boolean | undefined
  >
) => {
  const focusedRef = React.useRef<any>(null);
  return (
    <MUIAutocomplete
      disablePortal
      PaperComponent={({ children, ...props }) => (
        <Paper
          {...props}
          elevation={3}
          sx={{
            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
          }}
        >
          {React.Children.map(children, (child) => child)}
        </Paper>
      )}
      {...props}
      onFocus={(e) => {
        if (props.onFocus) props.onFocus(e);
        focusedRef.current = e.target;
      }}
      onBlur={(e) => {
        if (props.onBlur) props.onBlur(e);
        focusedRef.current = null;
      }}
      onChange={(e, data, reason) => {
        focusedRef.current?.blur();
        if (props.onChange) props.onChange(e, data, reason);
      }}
    />
  );
};
